<template>
	<div>
		<div>
			<el-row>
				<el-col :span="24">
					<span class="选择盒子 ml-5">
						查询日期:
						<el-date-picker value-format="yyyy-MM-dd" :size="用户设置参数.查询表单尺寸" style="width: 220px;"
							v-model="查询表单.查询日期" type="daterange" align="right" unlink-panels range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
							:clearable="false"></el-date-picker>
					</span>

					<span class="选择盒子 ml-5">
						订单分类:
						<el-select v-model="查询表单.订单分类" placeholder="订单分类" class="width-100" :size="用户设置参数.查询表单尺寸"
							:disabled="type!=''">
							<el-option label="全部" value=""></el-option>
							<el-option v-for="item in 订单分类列表" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</span>

					<span class="选择盒子 ml-5">
						订单状态:
						<el-select v-model="查询表单.订单状态" placeholder="订单状态" class="width-100" :size="用户设置参数.查询表单尺寸">
							<el-option label="全部" value=""></el-option>
							<el-option label="未确认" value="未确认"></el-option>
							<el-option label="已确认" value="已确认"></el-option>
						</el-select>
					</span>

					<span class="选择盒子 ml-5">
						收款状态:
						<el-select v-model="查询表单.收款状态" placeholder="收款状态" class="width-100" :size="用户设置参数.查询表单尺寸">
							<el-option label="全部" value=""></el-option>
							<el-option label="未收款" value="未收款"></el-option>
							<el-option label="部分收款" value="部分收款"></el-option>
							<el-option label="已收全款" value="已收全款"></el-option>
						</el-select>
					</span>

					<span class="选择盒子 ml-5">
						是否欠费:
						<el-select v-model="查询表单.是否欠费" placeholder="是否欠费" class="width-100" :size="用户设置参数.查询表单尺寸">
							<el-option label="全部" value=""></el-option>
							<el-option label="否" value="否"></el-option>
							<el-option label="是" value="是"></el-option>
						</el-select>
					</span>

					<span class="选择盒子 ml-5">
						外调付款状态:
						<el-select v-model="查询表单.外调付款状态" placeholder="外调付款状态" class="width-100" :size="用户设置参数.查询表单尺寸">
							<el-option label="全部" value=""></el-option>
							<el-option label="未付款" value="未付款"></el-option>
							<el-option label="已付款" value="已付款"></el-option>
						</el-select>
					</span>

					<span class="选择盒子 ml-5">
						业务费用付款状态:
						<el-select v-model="查询表单.业务费用付款状态" placeholder="业务费用付款状态" class="width-100"
							:size="用户设置参数.查询表单尺寸">
							<el-option label="全部" value=""></el-option>
							<el-option label="未付款" value="未付款"></el-option>
							<el-option label="已付款" value="已付款"></el-option>
						</el-select>
					</span>

					<span class="选择盒子 ml-5">
						付款方式:
						<el-select v-model="查询表单.付款方式" placeholder="付款方式" class="width-100" :size="用户设置参数.查询表单尺寸">
							<el-option label="全部" value=""></el-option>
							<el-option v-for="item in 付款方式列表" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</span>

					<span class="选择盒子 ml-5">
						车辆分类:
						<el-select v-model="查询表单.车辆分类" placeholder="车辆分类" class="width-100" :size="用户设置参数.查询表单尺寸">
							<el-option label="全部" value=""></el-option>
							<el-option v-for="item in 车辆分类列表" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</span>

					<span class="ml-5">
						<el-autocomplete v-model="查询表单.车牌号码" :fetch-suggestions="查询车牌号码" placeholder="车牌号码"
							:size="用户设置参数.查询表单尺寸" class="width-150"></el-autocomplete>
					</span>

					<span class="ml-5">
						<el-input style="width: 100px;" v-model="查询表单.业务员" placeholder="业务员" :size="用户设置参数.查询表单尺寸">
						</el-input>
					</span>
					<span class="ml-5">
						<el-input style="width: 100px;" v-model="查询表单.订单编号" placeholder="订单编号" :size="用户设置参数.查询表单尺寸">
						</el-input>
					</span>
					<span class="ml-5">
						<el-input style="width: 100px;" v-model="查询表单.客户名称" placeholder="客户名称" :size="用户设置参数.查询表单尺寸">
						</el-input>
					</span>
					<span class="ml-5">
						<el-input style="width: 100px;" v-model="查询表单.驾驶员" placeholder="驾驶员" :size="用户设置参数.查询表单尺寸">
						</el-input>
					</span>
					<span class="ml-5">
						<el-input style="width: 100px;" v-model="查询表单.行程描述" placeholder="行程描述" :size="用户设置参数.查询表单尺寸">
						</el-input>
					</span>
					<span class="ml-5">
						<el-input style="width: 100px;" v-model="查询表单.联系人" placeholder="联系人" :size="用户设置参数.查询表单尺寸">
						</el-input>
					</span>
					<span class="ml-5">
						<el-input style="width: 100px;" v-model="查询表单.车主单位" placeholder="车主单位" :size="用户设置参数.查询表单尺寸">
						</el-input>
					</span>
					<span class="ml-5">
						<el-input style="width: 100px;" v-model="查询表单.登单人" placeholder="登单人" :size="用户设置参数.查询表单尺寸">
						</el-input>
					</span>

					<el-button @click="查询数据()" type="primary" :class="'ml-10 ' + 用户设置参数.操作按钮尺寸" size="mini">查询
					</el-button>
				</el-col>
			</el-row>
		</div>

		<div>
			<el-card class="mt-10" shadow="always" :body-style="{ padding: '8px' }" style="background: #f5fafe;">
				<div>
					<el-button v-if="批量删除订单权限 == '订单系统-批量删除订单'" @click="批量删除订单()" :class="用户设置参数.操作按钮尺寸" size="mini"
						type="danger" icon="el-icon-delete-solid">
						批量删除
					</el-button>
					<el-button v-if="新增订单权限 == '订单系统-新增订单' && type" @click="显示添加订单=true" :class="用户设置参数.操作按钮尺寸"
						size="mini" type="primary" icon="el-icon-folder-add">
						新增{{type}}订单
					</el-button>
					<el-button v-if="导出订单表格登单人权限 == '订单系统-导出订单表格-登单人' || 导出订单表格全部权限 == '订单系统-导出订单表格-全部'"
						@click="订单导出全部()" :class="用户设置参数.操作按钮尺寸" size="mini" type="warning" icon="el-icon-download">
						导出
					</el-button>
					<el-button v-if="批量打印订单权限 == '订单系统-批量打印订单'" @click="显示打印预览 = true" :class="用户设置参数.操作按钮尺寸"
						size="mini" type="success" icon="el-icon-printer">
						打印预览
					</el-button>

					<el-button @click="查询数据(1)" type="primary" icon="el-icon-refresh" :class="'f-r ' + 用户设置参数.操作按钮尺寸"
						size="mini" circle></el-button>
					<el-tag type="info" :class="'f-r ' + 用户设置参数.操作按钮尺寸" effect="dark">共有数据：{{ 共有数据 }} 条</el-tag>
					<span class="f-r mr-5">
						每页:
						<el-select v-model="查询表单.每页显示" class="width-80" :size="用户设置参数.查询表单尺寸" @change="查询数据()">
							<el-option label="50" :value="50"></el-option>
							<el-option label="100" :value="100"></el-option>
							<el-option label="200" :value="200"></el-option>
							<el-option label="500" :value="500"></el-option>
							<el-option label="1000" :value="1000"></el-option>
						</el-select>
						条
					</span>
					<span class="f-r mr-5">
						高度:
						<el-select v-model="表格高度" class="width-100" :size="用户设置参数.查询表单尺寸">
							<el-option label="400" :value="400"></el-option>
							<el-option label="600" :value="600"></el-option>
							<el-option label="750" :value="750"></el-option>
							<el-option label="999" :value="999"></el-option>
							<el-option label="9999" :value="9999"></el-option>
							<el-option label="99999" :value="99999"></el-option>
							<el-option label="999999" :value="999999"></el-option>
							<el-option label="9999999" :value="9999999"></el-option>
						</el-select>
					</span>
					<span class="f-r mr-5">
						排序:
						<el-select v-model="查询表单.排序字段" class="width-100" :size="用户设置参数.查询表单尺寸" @change="查询数据()">
							<el-option label="发车日期" value="发车日期"></el-option>
							<el-option label="登单日期" value="登单日期"></el-option>
							<el-option label="订单编号" value="订单编号"></el-option>
							<el-option label="业务员" value="业务员"></el-option>
							<el-option label="订单状态" value="订单状态"></el-option>
							<el-option label="订单类型" value="订单类型"></el-option>
							<el-option label="收款状态" value="收款状态"></el-option>
							<el-option label="是否欠费" value="是否欠费"></el-option>
							<el-option label="车牌号码" value="车牌号码"></el-option>
						</el-select>
						<el-select v-model="查询表单.排序规则" class="width-80" :size="用户设置参数.查询表单尺寸" @change="查询数据()">
							<el-option label="降序" value="desc"></el-option>
							<el-option label="升序" value="asc"></el-option>
						</el-select>
					</span>
				</div>
			</el-card>
		</div>

		<el-divider>
			<el-tag :class="用户设置参数.数据统计尺寸" effect="plain" type="danger">应收费用:{{ 订单统计.总应收费用 }} 业务费用:{{ 订单统计.总业务费用 }}
				应付外调车租:{{ 订单统计.总应付外调车租 }}</el-tag>
		</el-divider>

		<div>
			<template>
				<el-table :data="表格数据" stripe border :max-height="表格高度" v-loading="表格加载状态" element-loading-text="拼命加载中"
					element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
					class="f-12" style="width: 100%;" @selection-change="table_xuanze_huitiao">
					<el-table-column align="center" type="selection" min-width="35"></el-table-column>
					<el-table-column align="center" label="编辑" min-width="85">
						<template slot-scope="scope">
							<div>
								<template v-if="
										修改订单车辆信息权限 == '订单系统-修改订单-车辆信息' ||
											修改订单管理员权限 == '订单系统-修改订单-管理员' ||
											修改订单权限 == '订单系统-修改订单' ||
											修改订单报销费用权限 == '订单系统-修改订单-报销费用'
									">
									<el-button :class="用户设置参数.操作按钮尺寸" size="mini" type="primary"
										@click="订单编辑(scope.row.订单编号)">编辑</el-button>
								</template>
								<template v-else>
									<el-button :class="用户设置参数.操作按钮尺寸" size="mini" type="primary"
										@click="订单编辑(scope.row.订单编号)">查看</el-button>
								</template>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="订单编号" min-width="100">
						<template slot-scope="scope">
							<div class="c-warning">{{ scope.row.业务员 }}</div>
							<div class="c-warning">{{ scope.row.订单编号 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="订单分类" min-width="70">
						<template slot-scope="scope">
							<div class="c-black">{{ scope.row.订单分类 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="客户名称" min-width="120">
						<template slot-scope="scope">
							<div class="c-black">{{ scope.row.客户名称 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="发车日期" min-width="90">
						<template slot-scope="scope">
							<div class="c-blue">{{ scope.row.发车日期.slice(0, 10) }}</div>
							<div class="c-blue">{{ scope.row.发车日期.slice(11, 19) }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="结束日期" min-width="90">
						<template slot-scope="scope">
							<div class="c-blue">{{ scope.row.结束日期.slice(0, 10) }}</div>
							<div class="c-blue">{{ scope.row.结束日期.slice(11, 19) }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="订单类型" min-width="50">
						<template slot-scope="scope">
							<div class="c-error">{{ scope.row.订单类型 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="车辆分类" min-width="110">
						<template slot-scope="scope">
							<div class="c-error">{{ scope.row.车辆分类 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="座位需求" min-width="100">
						<template slot-scope="scope">
							<div class="c-error">{{ scope.row.座位需求 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="车牌号码" min-width="90">
						<template slot-scope="scope">
							<div class="c-blue">{{ scope.row.车牌号码 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="驾驶员和手机" min-width="140">
						<template slot-scope="scope">
							<div class="c-blue">{{ scope.row.驾驶员 }}{{ scope.row.驾驶员手机 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="行程描述" min-width="350">
						<template slot-scope="scope">
							<span class="c-black">{{ scope.row.行程描述 }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="油卡编号" min-width="160">
						<template slot-scope="scope">
							<span class="c-black">{{ scope.row.油卡编号 }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="油卡充值时间" min-width="160">
						<template slot-scope="scope">
							<span class="c-black" v-if="scope.row.油卡">{{ scope.row.油卡.充值时间 }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="油卡充值时间" min-width="100">
						<template slot-scope="scope">
							<span class="c-black" v-if="scope.row.油卡">{{ scope.row.油卡.充值金额 }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="送车时间" min-width="160">
						<template slot-scope="scope">
							<span class="c-black">{{ scope.row.送车时间 }}</span>
						</template>
					</el-table-column>

					<el-table-column align="center" label="应收费用" min-width="100">
						<template slot-scope="scope">
							<div class="c-red">{{ scope.row.应收费用 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="业务费用" min-width="100">
						<template slot-scope="scope">
							<div class="c-red">{{ scope.row.业务费用 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="应付外调车租" min-width="100">
						<template slot-scope="scope">
							<div class="c-red">{{ scope.row.应付外调车租 }}</div>
						</template>
					</el-table-column>

					<el-table-column align="center" label="付款方式" min-width="100">
						<template slot-scope="scope">
							<div>
								<el-tag type="info" effect="dark" size="small">{{ scope.row.付款方式 }}</el-tag>
							</div>
						</template>
					</el-table-column>

					<el-table-column align="center" label="品牌型号需求" min-width="80">
						<template slot-scope="scope">
							<div class="c-error">{{ scope.row.品牌型号需求 }}</div>
						</template>
					</el-table-column>

					<el-table-column align="center" label="车主单位" min-width="100">
						<template slot-scope="scope">
							<div class="c-blue">{{ scope.row.车主单位 }}</div>
						</template>
					</el-table-column>

					<el-table-column align="center" label="实际收款金额" min-width="100">
						<template slot-scope="scope">
							<div class="c-red">{{ scope.row.实际收款金额 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="收款状态" min-width="100">
						<template slot-scope="scope">
							<div v-if="scope.row.收款状态 == '未收款'">
								<el-tag size="small" effect="dark" type="info">{{ scope.row.收款状态 }}</el-tag>
							</div>
							<div v-if="scope.row.收款状态 == '部分收款'">
								<el-tag size="small" effect="dark" type="warning">{{ scope.row.收款状态 }}</el-tag>
							</div>
							<div v-if="scope.row.收款状态 == '已收全款'">
								<el-tag size="small" effect="dark" type="success">{{ scope.row.收款状态 }}</el-tag>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="是否欠费" min-width="100">
						<template slot-scope="scope">
							<div class="mt-5" v-if="scope.row.是否欠费 == '是'">
								<el-tag size="small" color="#f55353" class="c-white">{{ scope.row.是否欠费 }}</el-tag>
							</div>
							<div class="mt-5" v-if="scope.row.是否欠费 == '否'">
								<el-tag size="small" effect="dark" type="success">{{ scope.row.是否欠费 }}</el-tag>
							</div>
						</template>
					</el-table-column>

					<el-table-column align="center" label="业务费用" min-width="100">
						<template slot-scope="scope">
							<div v-if="scope.row.业务费用付款状态 == '无需付款'">
								<el-tag size="small" effect="dark" type="info">{{ scope.row.业务费用付款状态 }}</el-tag>
							</div>
							<div class="mt-5" v-if="scope.row.业务费用付款状态 == '未付款'">
								<el-tag size="small" color="#f55353" class="c-white">{{ scope.row.业务费用付款状态 }}</el-tag>
							</div>
							<div class="mt-5" v-else-if="scope.row.业务费用付款状态 == '已付款'">
								<el-tag size="small" effect="dark" type="success">{{ scope.row.业务费用付款状态 }}</el-tag>
							</div>
						</template>
					</el-table-column>

					<el-table-column align="center" label="应付外调车租" min-width="100">
						<template slot-scope="scope">
							<div v-if="scope.row.外调付款状态 == '无需付款'">
								<el-tag size="small" effect="dark" type="info">{{ scope.row.外调付款状态 }}</el-tag>
							</div>
							<div class="mt-5" v-if="scope.row.外调付款状态 == '未付款'">
								<el-tag size="small" color="#f55353" class="c-white">{{ scope.row.外调付款状态 }}</el-tag>
							</div>
							<div class="mt-5" v-else-if="scope.row.外调付款状态 == '已付款'">
								<el-tag size="small" effect="dark" type="success">{{ scope.row.外调付款状态 }}</el-tag>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="联系人" min-width="100">
						<template slot-scope="scope">
							<div class="c-blue">{{ scope.row.联系人 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="联系人手机" min-width="100">
						<template slot-scope="scope">
							<div class="c-blue">{{ scope.row.联系人手机 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="登单信息" min-width="90">
						<template slot-scope="scope">
							<div class="c-error">{{ scope.row.登单人 }}</div>
							<div class="c-error">{{ scope.row.登单日期.slice(0, 10) }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="备注" min-width="150">
						<template slot-scope="scope">
							<div class="c-error">{{ scope.row.备注 }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="订单状态" min-width="80">
						<template slot-scope="scope">
							<div v-if="scope.row.订单状态 == '未确认'">
								<template v-if="确认订单权限 == '订单审核-确认订单'">
									<el-tag @click="确认订单(scope.row.订单编号)" size="medium" effect="dark" type="info">
										{{ scope.row.订单状态 }}
									</el-tag>
								</template>
								<template v-else>
									<el-tag size="medium" effect="dark" type="info">{{ scope.row.订单状态 }}</el-tag>
								</template>
							</div>
							<div v-else-if="scope.row.订单状态 == '已确认'">
								<template v-if="反审核权限 == '订单审核-反审核'">
									<el-tag @click="反审核订单(scope.row.订单编号)" size="medium" effect="dark" type="success">
										{{ scope.row.订单状态 }}
									</el-tag>
								</template>
								<template v-else>
									<el-tag size="medium" effect="dark" type="success">{{ scope.row.订单状态 }}</el-tag>
								</template>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="删除" min-width="85">
						<template slot-scope="scope">
							<div v-if="删除订单权限 == '订单系统-删除订单'">
								<el-button :class="用户设置参数.操作按钮尺寸" size="mini" type="danger"
									@click="删除订单(scope.row.订单编号)">删除
								</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination background layout="total, prev, pager, next" :page-size="查询表单.每页显示" :total="共有数据"
					:pager-count="11" @current-change="tiaozhuan" prev-text="上一页" next-text="下一页">
				</el-pagination>
			</template>
		</div>

		<el-drawer title="添加订单" :visible.sync="显示添加订单" v-if="显示添加订单" :with-header="false" direction="ttb" size="95%">
			<dingdan-add :type="type" @close="close_dingdan_add" @shuaxin_sandan="shuaxin_sandan"></dingdan-add>
		</el-drawer>

		<el-drawer title="订单编辑" :visible.sync="显示订单编辑" v-if="显示订单编辑" :with-header="false" direction="ttb" size="95%">
			<dingdan-edit :dingdanbianhao="订单编号" @close="close_dingdan_bianji" @shuaxin_sandan="shuaxin_sandan">
			</dingdan-edit>
		</el-drawer>

		<el-dialog title="导出文件" :visible.sync="显示导出提示" width="30%" center>
			<div class="text-c">
				<div>
					<el-progress type="circle" :percentage="导出文件进度" :status="导出文件状态"></el-progress>
				</div>
				<div>
					<el-link class="f-28" type="primary" v-show="导出文件链接状态" :href="导出文件链接">下载导出的文件</el-link>
				</div>
				<div class="f-14">{{ 导出文件提示 }}</div>
			</div>
		</el-dialog>

		<el-drawer title="打印预览" :visible.sync="显示打印预览" :with-header="false" direction="ttb" size="90%">
			<div class="text-c mt-10">
				<el-button @click="打印()" :class="用户设置参数.操作按钮尺寸" size="mini" type="success" icon="el-icon-printer">
					立即打印</el-button>
				<el-button @click="显示打印预览 = false" :class="用户设置参数.操作按钮尺寸" size="mini" type="danger"
					icon="el-icon-close">关闭预览
				</el-button>
			</div>
			<div id="dayin1">
				<div class="text-c mt-5" style="font-size: 20px;">
					日期：{{ 查询表单.查询日期[0] }}----{{ 查询表单.查询日期[1] }}（{{ type }}）订单列表
				</div>
				<div class="text-c mt-5" style="font-size: 20px;color: #FF0000;">应收费用:{{ 订单统计.总应收费用 }}
					业务费用:{{ 订单统计.总业务费用 }} 应付外调车租:{{ 订单统计.总应付外调车租 }}</div>
				<table id="sandanbg" style="width:350mm;" class="table radius mt-10 table-yanse f-12" border="1"
					cellpadding="1" align="center">
					<thead>
						<tr class="text-c">
							<th>订单编号</th>
							<th>客户名称</th>
							<th>发车日期</th>
							<th>结束日期</th>
							<th>车辆需求</th>
							<th>车辆信息</th>
							<th>行程描述</th>
							<th>应收费用</th>
							<th>业务费用</th>
							<th>应付外调车租</th>
							<th>联系人</th>
							<th>登单信息</th>
						</tr>
					</thead>
					<tbody>
						<tr class="text-c" v-for="(订单, index) in 表格数据" :key="index">
							<td width="6%" style="color: #F37B1D;">
								<div>{{ 订单.业务员 }}</div>
								<div>{{ 订单.订单编号 }}</div>
								<div v-if="订单.订单状态 == '未确认'" style="color: #8b8b8b;">{{ 订单.订单状态 }}</div>
								<div v-if="订单.订单状态 == '已确认'" style="color: #549c2e;">{{ 订单.订单状态 }}</div>
							</td>
							<td width="6%" style="color: #000000;">
								<div>{{ 订单.客户名称 }}</div>
								<div style="color: #f20000;">{{ 订单.付款方式 }}</div>
							</td>
							<td width="6%" style="color: #0000FF;">{{ 订单.发车日期 }}</td>
							<td width="6%" style="color: #0000FF;">{{ 订单.结束日期 }}</td>
							<td width="5%" style="color: #dd3a3a;">
								<div>{{ 订单.品牌型号需求 }}</div>
								<div>{{ 订单.座位需求 }}座</div>
								<div>{{ 订单.车辆分类 }}</div>
								<div>{{ 订单.订单类型 }}</div>
							</td>
							<td width="7%" style="color: #0000FF;">
								<div>{{ 订单.车主单位 }}</div>
								<div>{{ 订单.车牌号码 }}</div>
								<div>{{ 订单.驾驶员 }}</div>
								<div>{{ 订单.驾驶员手机 }}</div>
							</td>
							<td width="20%" style="color: #000000;">{{ 订单.行程描述 }}</td>
							<td width="8%" style="color: #FF0000;">
								<div>应收：{{ 订单.应收费用 }}</div>
								<div>已收：{{ 订单.实际收款金额 }}</div>
								<div v-if="订单.收款状态 == '未收款'" style="color: #8b8b8b;">{{ 订单.收款状态 }}</div>
								<div v-if="订单.收款状态 == '已收款'" style="color: #549c2e;">{{ 订单.收款状态 }}</div>
								<div v-if="订单.是否欠费 == '欠费中'" style="color: #ff0000;">{{ 订单.是否欠费 }}</div>
								<div v-if="订单.是否欠费 == '已收全款'" style="color: #549c2e;">{{ 订单.是否欠费 }}</div>
							</td>
							<td width="6%" style="color: #FF0000;">
								<div>应付：{{ 订单.业务费用 }}</div>
								<div v-if="订单.业务费用付款状态 == '无需付款'" style="color: #8b8b8b;">{{ 订单.业务费用付款状态 }}</div>
								<div v-if="订单.业务费用付款状态 == '未付款'" style="color: #ff0000;">{{ 订单.业务费用付款状态 }}</div>
								<div v-if="订单.业务费用付款状态 == '已付款'" style="color: #549c2e;">{{ 订单.业务费用付款状态 }}</div>
							</td>
							<td width="6%" style="color: #FF0000;">
								<div>应付：{{ 订单.应付外调车租 }}</div>
								<div v-if="订单.外调付款状态 == '无需付款'" style="color: #8b8b8b;">{{ 订单.外调付款状态 }}</div>
								<div v-if="订单.外调付款状态 == '未付款'" style="color: #ff0000;">{{ 订单.外调付款状态 }}</div>
								<div v-if="订单.外调付款状态 == '已付款'" style="color: #549c2e;">{{ 订单.外调付款状态 }}</div>
							</td>
							<td width="6%" style="color: #0000FF;">
								<div>{{ 订单.联系人 }}</div>
								<div>{{ 订单.联系人手机 }}</div>
							</td>
							<td width="6%" style="color: #bc3d3d;">
								<div>{{ 订单.登单人 }}</div>
								<div>{{ 订单.登单日期.slice(0, 10) }}</div>
								<div>{{ 订单.登单日期.slice(11, 19) }}</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</el-drawer>


	</div>
</template>

<script>
	export default {
		name: 'dingdan-table',
		props: {
			type: String
		},
		data() {
			return {
				用户设置参数: JSON.parse(localStorage.getItem('用户设置参数')),
				表格高度: 600,
				共有数据: 0,

				表格加载状态: true,
				表格数据: [],
				显示添加订单: false,
				订单统计: {
					总应收费用: 0,
					总业务费用: 0,
					总应付外调车租: 0,
				},
				订单编号: '',
				显示订单编辑: false,
				显示打印预览: false,
				已选择的订单: '',

				查询表单: {
					订单分类: this.type,
					page: 1,
					排序字段: '订单编号',
					排序规则: 'desc',
					每页显示: 50,
					查询日期: [new Date().toLocaleDateString().replace(/\//g, '-'), new Date().toLocaleDateString().replace(
						/\//g,
						'-')],
					发车日期: new Date().toLocaleDateString().replace(/\//g, '-'),
					结束日期: new Date().toLocaleDateString().replace(/\//g, '-'),
					订单状态: '',
					收款状态: '',
					是否欠费: '',
					外调付款状态: '',
					业务费用付款状态: '',
					付款方式: '',
					车辆分类: '',
					车牌号码: '',
					业务员: '',
					订单编号: '',
					客户名称: '',
					驾驶员: '',
					行程描述: '',
					联系人: '',
					车主单位: '',
					登单人: '',
				},
				pickerOptions: {
					shortcuts: [{
							text: '今天',
							onClick(picker) {
								const d = new Date();
								const end = new Date(d.getFullYear(), d.getMonth(), d.getDate());
								const start = new Date(d.getFullYear(), d.getMonth(), d.getDate());
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '今月',
							onClick(picker) {
								const d = new Date();
								const end = new Date(d.getFullYear(), d.getMonth() + 1, 0);
								const start = new Date(d.getFullYear(), d.getMonth(), 1);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '上月',
							onClick(picker) {
								const d = new Date();
								const end = new Date(d.getFullYear(), d.getMonth(), 0);
								const start = new Date(d.getFullYear(), d.getMonth() - 1, 1);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '今年',
							onClick(picker) {
								const d = new Date();
								const end = new Date(d.getFullYear(), 12, 0);
								const start = new Date(d.getFullYear(), 0, 1);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '去年',
							onClick(picker) {
								const d = new Date();
								const end = new Date(d.getFullYear() - 1, 12, 0);
								const start = new Date(d.getFullYear() - 1, 0, 1);
								picker.$emit('pick', [start, end]);
							}
						}
					]
				},

				订单分类列表: [],
				付款方式列表: [],
				车辆分类列表: [],

				确认订单权限: '',
				反审核权限: '',
				删除订单权限: '',
				批量删除订单权限: '',
				新增订单权限: '',
				导出订单表格登单人权限: '',
				导出订单表格全部权限: '',
				批量打印订单权限: '',
				修改订单车辆信息权限: '',
				修改订单管理员权限: '',
				修改订单权限: '',
				修改订单报销费用权限: '',

				导出文件提示: '',
				导出文件链接: '',
				导出定时器: '',
				导出文件状态: null,
				导出文件进度: 5,
				显示导出提示: false,
				导出文件链接状态: false,

			};
		},
		created: function() {
			this.获取默认参数();
		},
		methods: {
			获取默认参数() {
				this.$http.post('get/dingdan/list').then(返回数据 => {
					//console.log(返回数据);

					let 订单分类数组 = 返回数据.订单分类;
					let 订单分类数组长度 = 订单分类数组.length;
					for (let i = 0; i < 订单分类数组长度; i++) {
						this.订单分类列表.push({
							value: 订单分类数组[i],
							label: 订单分类数组[i]
						});
					}

					let 付款方式数组 = 返回数据.付款方式;
					let 付款方式数组长度 = 付款方式数组.length;
					for (let i = 0; i < 付款方式数组长度; i++) {
						this.付款方式列表.push({
							value: 付款方式数组[i],
							label: 付款方式数组[i]
						});
					}

					let 车辆分类数组 = 返回数据.车辆分类;
					let 车辆分类数组长度 = 车辆分类数组.length;
					for (let i = 0; i < 车辆分类数组长度; i++) {
						this.车辆分类列表.push({
							value: 车辆分类数组[i],
							label: 车辆分类数组[i]
						});
					}

					this.确认订单权限 = 返回数据.确认订单权限;
					this.反审核权限 = 返回数据.反审核权限;
					this.删除订单权限 = 返回数据.删除订单权限;
					this.批量删除订单权限 = 返回数据.批量删除订单权限;
					this.新增订单权限 = 返回数据.新增订单权限;
					this.导出订单表格登单人权限 = 返回数据.导出订单表格登单人权限;
					this.导出订单表格全部权限 = 返回数据.导出订单表格全部权限;
					this.批量打印订单权限 = 返回数据.批量打印订单权限;
					this.修改订单车辆信息权限 = 返回数据.修改订单车辆信息权限;
					this.修改订单管理员权限 = 返回数据.修改订单管理员权限;
					this.修改订单权限 = 返回数据.修改订单权限;
					this.修改订单报销费用权限 = 返回数据.修改订单报销费用权限;
					this.查询数据(1);
				});
			},
			查询数据(page = 1) {
				this.查询表单.发车日期 = this.查询表单.查询日期[0];
				this.查询表单.结束日期 = this.查询表单.查询日期[1];
				this.表格加载状态 = true;
				this.查询表单.page = page;
				this.$http
					.post('dingdan/gg/list', this.查询表单)
					.then(返回数据 => {
						this.表格数据 = 返回数据.数据.list.data;
						this.共有数据 = 返回数据.数据.list.total;
						this.订单统计 = 返回数据.数据.订单统计;
						this.表格加载状态 = false;
					});
			},
			订单导出全部() {
				this.查询表单.发车日期 = this.查询表单.查询日期[0];
				this.查询表单.结束日期 = this.查询表单.查询日期[1];
				var that = this;
				clearInterval(that.导出定时器);
				that.导出文件进度 = 5;
				console.log(that.导出文件进度);
				that.导出文件状态 = null;
				that.显示导出提示 = true;
				that.导出定时器 = setInterval(function() {
					if (that.导出文件进度 < 99) {
						that.导出文件进度 = that.导出文件进度 + 1;
					} else {
						that.导出文件提示 = '当前导出缓慢，请耐心等待，不用关闭导出窗口！';
						that.导出文件进度 = 99;
					}
					console.log(that.导出文件进度);
				}, 500);
				this.$http
					.post('dingdan/gg/daochuExcelALL', this.查询表单)
					.then(返回数据 => {
						clearInterval(that.导出定时器);
						that.导出文件提示 = '';
						that.导出文件进度 = 100;
						that.导出文件状态 = 'success';
						that.导出文件链接 = 返回数据.导出文件位置;
						that.导出文件链接状态 = true;
						console.log(返回数据);
					});
			},
			table_xuanze_huitiao(val) {
				//console.log(val);
				this.已选择的订单 = '';
				for (let i = 0; i < val.length; i++) {
					if (this.已选择的订单.indexOf(val[i].订单编号) === -1) {
						this.已选择的订单 += val[i].订单编号 + ',';
					}
				}
				console.log(this.已选择的订单);
			},
			tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.查询数据(val);
			},
			close_dingdan_add(e) {
				//console.log(e);
				this.显示添加订单 = e;
			},
			shuaxin_sandan() {
				this.查询数据(1);
			},
			订单编辑(订单编号) {
				//console.log(订单编号);
				this.订单编号 = 订单编号;
				this.显示订单编辑 = true;
			},
			close_dingdan_bianji(e) {
				//console.log(e);
				this.显示订单编辑 = e;
			},
			查询车牌号码(queryString, cb) {
				this.$http
					.post('get/cheliangxinxi/chepaihaoma', {
						车牌号码: queryString
					})
					.then(返回数据 => {
						let 车牌号码列表 = new Array();
						let 车牌号码数组 = 返回数据.车牌号码;
						let 车牌号码数组长度 = 车牌号码数组.length;
						for (let i = 0; i < 车牌号码数组长度; i++) {
							车牌号码列表.push({
								value: 车牌号码数组[i]
							});
						}
						cb(车牌号码列表);
					});
			},
			打印() {
				var mywindow = window.open('', 'PRINT', 'height=400,width=600');

				mywindow.document.write('<html><head><title>' + document.title + '</title>');
				mywindow.document.write(
					'<style type="text/css">table{width:100%;empty-cells:show;background-color:transparent;border-collapse:collapse;border-spacing:0}table th{text-align:center; font-weight:400}.radius{border-radius:4px}.table-yanse{border: thin solid #ff0000;}.mt-5{margin-top:5px}.mt-10{margin-top:10px}.mt-15{margin-top:15px}.mt-20{margin-top:20px}.mt-25{margin-top:25px}.mt-30{margin-top:30px}.f-12{font-size:12px}.text-c{text-align:center}</style>'
				);
				mywindow.document.write('</head><body >');
				mywindow.document.write(document.getElementById('dayin1').innerHTML);
				mywindow.document.write('</body></html>');

				mywindow.document.close(); // necessary for IE >= 10
				mywindow.focus(); // necessary for IE >= 10*/

				mywindow.print();
				mywindow.close();

				return true;
			},
			删除订单(订单编号) {
				this.$prompt('确定要删除订单吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						inputPattern: /\S/,
						inputErrorMessage: '删除说明不能为空',
						inputPlaceholder: '删除说明'
					})
					.then(({
						value
					}) => {
						this.$http
							.post('dingdan/gg/del_dingdan', {
								订单编号: 订单编号,
								删除说明: value
							})
							.then(response => {
								this.$message.success(response.信息);
								this.查询数据(1);
							});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			},
			批量删除订单() {
				if (this.已选择的订单) {
					this.$prompt('确定要删除选中的订单吗?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							inputPattern: /\S/,
							inputErrorMessage: '删除说明不能为空',
							inputPlaceholder: '删除说明'
						})
						.then(({
							value
						}) => {
							this.$http
								.post('dingdan/gg/del_dingdan_all', {
									已选择的订单: this.已选择的订单,
									删除说明: value
								})
								.then(response => {
									this.$message.success(response.信息);
									this.查询数据(1);
								});
						})
						.catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						});
				} else {
					this.$message.error('请先选择需要删除的订单');
				}
			},
			确认订单(订单编号) {
				this.$confirm('确定要确认' + 订单编号 + '订单吗?', '提示', {
						confirmButtonText: '立即确认',
						cancelButtonText: '取消'
					})
					.then(() => {
						this.$http
							.post('dingdan/gg/dingdanshenhe_queren', {
								订单编号: 订单编号
							})
							.then(response => {
								this.$message.success(response.信息);
								this.查询数据(1);
							});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消确认订单'
						});
					});
			},
			反审核订单(订单编号) {
				this.$confirm('确定要反审核' + 订单编号 + '订单吗?', '提示', {
						confirmButtonText: '立即反审核',
						cancelButtonText: '取消'
					})
					.then(() => {
						this.$http
							.post('dingdan/gg/dingdanshenhe_fanshenhe', {
								订单编号: 订单编号
							})
							.then(response => {
								this.$message.success(response.信息);
								this.查询数据(1);
							});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消反审核订单'
						});
					});
			}


		}
	};
</script>

<style scoped>
	.el-radio.is-bordered+.el-radio.is-bordered {
		margin-left: 0px;
	}
</style>
